<template>
    <div id="app">
        <!-- Toast é um componente global para notificações do sistema -->
        <Toast />

        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </div>
</template>

<script>
import { defineComponent, onMounted, watch } from 'vue'
import Toast from '@/components/ui/Toast.vue'
import { useEmpresaStore } from '@/stores/empresa'
import { useUsuarioStore } from '@/stores/usuario'

export default defineComponent({
    name: 'App',
    components: {
        Toast,
    },
    setup() {
        onMounted(() => {
            const empresaStore = useEmpresaStore();
            empresaStore.applyActiveTheme();
        });
        const usuarioStore = useUsuarioStore();

        watch(
            () => usuarioStore.dadosUsuario.idioma,
            (novoIdioma) => {

                if (novoIdioma) {
                    usuarioStore.setLocale(novoIdioma);
                }
            },
            { immediate: true }
        );
        return {};
    }
})
</script>

<style lang="scss">
#app {
    min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.vs__dropdown-menu {
  /* Seus estilos originais que queremos aplicar */
  color: #464646 !important;
  margin-top: 0.5rem !important;
  border-radius: 0.25rem 0.25rem 1rem 1rem !important;
  box-shadow: 0 0.4vh 0.4vh rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e0e0e0 !important;
  padding: 0 !important;
  max-height: 15rem !important;
  z-index: 99999 !important; /* Essencial para ficar por cima de tudo */
  scrollbar-width: none;
}

.vs__dropdown-option {
  padding: 0.8rem 1.3rem !important;
  font-size: 0.8rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #f0f0f0;
}

.vs__dropdown-option:last-child {
  border-bottom: none;
}

.vs__dropdown-option--highlight {
  background: var(--colorOpacity5) !important;
  color: black !important;
}
</style>
